import React from 'react';
import styled from 'styled-components';


const Wrapper = styled.div`
	.card {
		background-color: #fff;
		position: relative;
		background-size: cover;
		background-position: center;
	
		&:hover, a:hover {
			text-decoration: none;
		}
		
		.card-header {
			z-index: 10;
		}
	
		.card-body {
			.card {
				height: 85px;
				transition: .3s;
				-webkit-transition: .3s;
				-moz-transition: .3s;
				-ms-transition: .3s;
				-o-transition: .3s;
		
				&:hover {
					background-color: #004753!important;
					color: #fff!important;
				}
		
				i {
					font-size: 1rem;
				}
		
				.h6 {
					line-height: .5rem;
				}
			}
		}
	}
`

export default class RequestsHotelsCardPipeline extends React.Component {
    constructor(props) {
      super(props);
    }
  
    render(props) {
		const { 
			id,
			title, 
			checkin,
			checkout,
			accommodation,
			hotel,
			refRequest,
			refHotel,
			refCustomer,
			segment,
			lastViews,
			societe,
			requests,
			connectivityInfos

		} = this.props

      	return (
			<Wrapper className="mb-2">
				<a 
					href="#"
					data-part="+"
					data-target={'providers//requests_hotels/details/' + id}
					className="js-nav d-block card p-3 bg-gc-light-blue-dark border-none shadow-sm get_part_link"
				>
					<div className="card-header border-none text-gc-dark-blue bg-transparent p-0">
						<div className="mb-2">
							<h2 className="h6 font-weight-bold m-0" style={{lineHeight: '1rem'}}>
								{title}
							</h2>
							<span className="d-inline-block small font-weight-normal" style={{lineHeight: '1rem'}}>
								{'du_au'.trad().replace('%1',(checkin.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'}))).replace('%2',(checkout.formatDateTime({ year: 'numeric', month: 'numeric', day: 'numeric'}))).ucFirst()}
							</span>							
						</div>

						
					</div>
				</a>
			</Wrapper>
      	);
    }
}